/**
 *  The view (popup) that appear when you drag and drop a cargoRequest or bulk content.
 */
var VRC = VRC || {};
VRC.BulkLoadingPopoverView = (function(){

  var init = function ($placeHolder, droppedElement, config) {
    var jsonElement = droppedElement.toJson ? droppedElement.toJson() : droppedElement;

    var popOverHtml = WELL.Handlebars.VRC.loadingQuantitySelection({
      qtyRob : jsonElement.qtyRob - jsonElement.valueQty,
      date : moment().format(g_timeStampFormat),
      request: jsonElement,
      units: VRC.MasterDataService.getBulkValueUnitsAsArray(),
      action: config.action
    });

    $placeHolder.attr('data-content', popOverHtml);
    $placeHolder.popover({html: true,  placement: 'left auto', title : config.title, sanitize: false });
    $placeHolder.popover('show');

  };


  var show = function($dropzoneElement, droppedElement, onConfirm, onCancel, config){
    config = config || {};
    init($dropzoneElement, droppedElement, config);

    var $popover =  $dropzoneElement.next();

    var droppedElementJson = droppedElement.toJson ? droppedElement.toJson() : droppedElement;


    var $valueType = $popover.find('#popover__valueUnit');
    var $date = $popover.find('#popover__date');
    $valueType.selectpicker();
    $date.datetimepicker({format : g_timeStampFormat});
    var $valueQty = $popover.find('#popover__valueQty');

    var $bulkTypeId = $("#popover__bulkTypeId");
    var $qtyRob = $popover.find('#popover__qtyRob');
    var $remarkField = $popover.find('#popover__remarks');

    $valueQty.focus();

    $valueQty.change(function(e){

      var qty = $(e.target).val();
      $qtyRob.val(droppedElementJson.qtyRob - qty);
    });

    $('.bulk-insertion-cancel').click(function(e){
      e.preventDefault();
      $dropzoneElement.popover('destroy');
      if(onCancel){
        onCancel();
      }
    });

    $('.bulk-insertion-confirm').click(function(e){
      e.preventDefault();
      onConfirm($dropzoneElement, {$valueQty :$valueQty, $date : $date, $qtyRob : $qtyRob, $remarkField : $remarkField, $bulkTypeId : $bulkTypeId}, droppedElementJson);

    });
  };

  return {
    show : show
  }
})();
